import { Navigate } from "react-router-dom";
import { toast } from "react-toastify";
import broadcast from "./broadcast";
import file from "./file";
import notification from "./notification";
import sentence from "./sentence";
import speaker from "./speaker";
import user from "./user";

const api = {
  broadcast: broadcast,
  file: file,
  notification: notification,
  sentence: sentence,
  speaker: speaker,
  user: user,
};

function handleResponse(res: Response) {
  // console.log(res.status);
  if (res.status == 401){
    window.location.replace(process.env.PUBLIC_URL + "/login");
  }
  else if (res.status == 201) {
    toast.success("Successfully Created.")
  }
  else if (!res.ok) {
    throw Error(res.statusText);    
  } else {
    const contentType = res.headers.get("content-type");
    // console.log(contentType);
    if (contentType) {
      if (contentType.indexOf("application/json") !== -1 || contentType.indexOf("text/plain") !== -1) {
        return res.json();
      }
    } else {
      return res;
    }
  }
}
// console.log(process.env);

// export const APP_URI = "https://sc.newsclip.co.za";
// export constREACT_APP_API_URI = "https://sc-api.newsclip.co.za";
// export const AUTH_API_URI = "https://sc-api.newsclip.co.za";
// export const APP_URI = "http://localhost:3000";
// export constREACT_APP_API_URI = "https://localhost:44390";

export async function apiGet(url: string) {
  return fetch(url, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${localStorage.AccessToken}`,
      "Content-Type": "application/json",
    },
  }).then((res) => handleResponse(res));
}

export async function apiGetFile(url: string) {
  return fetch(url, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${localStorage.AccessToken}`,
      "Content-Type": "audio/wav",
    },
  })
  .then((res) => res.text())
}

export async function apiLogin(url: string, body?: object) {
  return fetch(url, {
    method: "POST",
    body: JSON.stringify(body),
    headers: {
      "Content-Type": "application/json",
    },
  }).then((res) => handleResponse(res));
}

export async function apiPost(url: string, body?: object) {
  return fetch(url, {
    method: "POST",
    body: JSON.stringify(body),
    headers: {
      Authorization: `Bearer ${localStorage.AccessToken}`,
      "Content-Type": "application/json",
    },
  }).then((res) => handleResponse(res));
}

export async function apiPut(url: string, body?: object) {
  return fetch(url, {
    method: "PUT",
    body: JSON.stringify(body),
    headers: {
      "Authorization": `Bearer ${localStorage.AccessToken}`,
      "Content-Type": "application/json"
    },
  }).then((res) => handleResponse(res));
}

export async function apiDelete(url: string, body?: object) {
  return fetch(url, {
    method: "DELETE",
    body: JSON.stringify(body),
    headers: {
      Authorization: `Bearer ${localStorage.AccessToken}`,
      "Content-Type": "application/json"
    },
  }).then((res) => handleResponse(res));
}

export default api;
